module.exports = __webpack_public_path__ + "static/media/125.aad87744.png";